import { connect } from 'react-redux';
import { saveDocument } from '../../store/actions/document';
import TruckComponent from './TruckComponent';
import { injectModal } from '../../contexts/modal-context';
import { StoreState } from '../../store/state';

const mapStateToProps = (state: StoreState, ownProps: any) => {
  let lineHaulCompanyName = '';
  if (state.linehaulCompanies.all) {
    const lineHaulCompany = state.linehaulCompanies.all[ownProps.truck.linehaulCompanyId];
    if (lineHaulCompany) {
      lineHaulCompanyName = lineHaulCompany.name;
    }
  }

  return {
    ...ownProps,
    lineHaulCompanyName,
  };
};

const mapDispatchToProps = {
  saveDocument: saveDocument.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectModal(TruckComponent));
